// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-3a409988] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.notecard[data-v-3a409988] {
  color: var(--color-main-text) !important;
  background-color: var(--note-background) !important;
  border-inline-start: 4px solid var(--note-theme);
  border-radius: var(--border-radius);
  margin: 1rem 0;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.notecard__icon--heading[data-v-3a409988] {
  margin-bottom: auto;
  margin-top: .3rem;
}
.notecard--success[data-v-3a409988] {
  --note-background: rgba(var(--color-success-rgb), .1);
  --note-theme: var(--color-success);
}
.notecard--info[data-v-3a409988] {
  --note-background: rgba(var(--color-info-rgb), .1);
  --note-theme: var(--color-info);
}
.notecard--error[data-v-3a409988] {
  --note-background: rgba(var(--color-error-rgb), .1);
  --note-theme: var(--color-error);
}
.notecard--warning[data-v-3a409988] {
  --note-background: rgba(var(--color-warning-rgb), .1);
  --note-theme: var(--color-warning);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-400b48a6.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,gDAAgD;EAChD,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;AACA;EACE,kDAAkD;EAClD,+BAA+B;AACjC;AACA;EACE,mDAAmD;EACnD,gCAAgC;AAClC;AACA;EACE,qDAAqD;EACrD,kCAAkC;AACpC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-3a409988] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.notecard[data-v-3a409988] {\n  color: var(--color-main-text) !important;\n  background-color: var(--note-background) !important;\n  border-inline-start: 4px solid var(--note-theme);\n  border-radius: var(--border-radius);\n  margin: 1rem 0;\n  padding: 1rem;\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n.notecard__icon--heading[data-v-3a409988] {\n  margin-bottom: auto;\n  margin-top: .3rem;\n}\n.notecard--success[data-v-3a409988] {\n  --note-background: rgba(var(--color-success-rgb), .1);\n  --note-theme: var(--color-success);\n}\n.notecard--info[data-v-3a409988] {\n  --note-background: rgba(var(--color-info-rgb), .1);\n  --note-theme: var(--color-info);\n}\n.notecard--error[data-v-3a409988] {\n  --note-background: rgba(var(--color-error-rgb), .1);\n  --note-theme: var(--color-error);\n}\n.notecard--warning[data-v-3a409988] {\n  --note-background: rgba(var(--color-warning-rgb), .1);\n  --note-theme: var(--color-warning);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
